export const AuthenticationModule = {
    state: () => ({
        popupBanned: false,
    }),
    mutations: {
        setPopupBanned(state, data) {
            state.popupBanned = data;
        },
    },
    namespaced: true,
};
